<style lang="stylus">
    .report-reason
        .container
          width: 100%;
          flex: 1;
        .textarea-count
            position relative
            margin-bottom 10px

            .string-count
                position absolute
                color $text-color-light
                bottom 2px
                right 10px
                line-height normal

        .report-reason-hint
            color $text-color-light
            font-weight normal
            font-size 12px
            margin-top 16px
            height auto
            min-height 20px
            white-space normal

        .ed-modal-body
            padding-bottom 4px
            padding-top 6px

        .ed-modal-header
            border none

        .ed-modal-footer
            border none
</style>

<template>
    <EDModal v-if="showReportReason" class="flex-center report-reason" ref="modal">
        <div class="container">
            <p class="report-reason-hint">{{ $t("reportInstruction") }}</p>
            <Form ref="form" :model="form" :rules="ruleValidate">
                <FormItem :label="$t('reportTypeLabel')" prop="reportRadio">
                    <RadioGroup v-model="form.reportRadio" vertical>
                        <Radio :label="0" :value="0">{{ $t("reportType1") }}</Radio>
                        <Radio :label="1" :value="1">{{ $t("reportType2") }}</Radio>
                        <Radio :label="2" :value="2">{{ $t("reportType3") }}</Radio>
                        <Radio :label="3" :value="3">{{ $t("reportType4") }}</Radio>
                    </RadioGroup>
                </FormItem>
                <FormItem :label="$t('reportResonLabel')" prop="reportReason" class="textarea-count">
                    <Input v-model.trim="form.reportReason" :placeholder="$t('reportReasonHint')" :clearable="true" type="textarea" />
                    <span :style="{ color: form.reportReason.length > 240 ? 'red' : '' }" class="string-count">
                        {{ form.reportReason.length }} / 240
                    </span>
                </FormItem>
            </Form>
        </div>
    </EDModal>
</template>

<script>
    import { addJs } from "@/public/utils/tool";

    export default {
        name: "",
        components: {},
        data() {
            return {
                showReportReason: false,
                form: {
                    reportReason: "",
                    reportRadio: 3,
                },

                loading: true,
            };
        },
        computed: {
            ruleValidate() {
                return {
                    reportReason: [
                        {
                            required: true,
                            message: this.$t("validateWarn.reasonRequire"),
                            trigger: "blur",
                        },
                        {
                            type: "string",
                            min: 5,
                            max: 240,
                            message: this.$t("validateWarn.reasonLength"),
                            trigger: "blur",
                        },
                    ],
                    reportRadio: [
                        {
                            required: true,
                        },
                    ],
                    callback: null,
                };
            },
        },
        watch: {
            showReportReason(nv, ov) {
                if (nv) {
                    this.$nextTick(() => {
                        let dom = this.$refs.modal;
                        dom.show({
                            title: this.$tc("report"),
                            useDark: this.isPCDarkMode,
                            isPC: this.isPC,
                            width: 560,
                            confirmText: this.$tc("okText"),
                            cancelText: this.$tc("cancelText"),
                            confirmEvent: () => {
                                this.doReport();
                            },
                            closeEvent: () => {
                                this.cancelReport();
                                this.showReportReason = false;
                            },
                        });
                    });
                }
            },
        },
        mounted() {},
        created() {
            this.$bus.$on("setReportAlertValue", this.setReportAlertValue);
        },
        beforeDestroy() {
            this.$bus.$off("setReportAlertValue", this.setReportAlertValue);
        },
        methods: {
            doReport() {
                this.$refs.form.validate((pass) => {
                    if (!pass) {
                        this.loading = false;
                        this.$nextTick(() => {
                            this.loading = true;
                        });
                        return;
                    }
                    let reason = this.params.id + ": " + this.form.reportReason;
                    this.$edApi
                        .viewOrReportWork(
                            Object.assign(
                                {
                                    workId: this.work.id,
                                    report: reason,
                                    report_type: this.form.reportRadio,
                                },
                                this.params
                            )
                        )
                        .then(() => {
                            this.$edMessage.success(this.$t("message.reportSuccess"));
                            this.showReportReason = false;
                            this.form.reportReason = "";
                            this.form.reportRadio = 3;
                            this.callback && this.callback();
                        })
                        .catch((e) => {
                            this.showReportReason = false;
                            this.form.reportReason = "";
                            this.form.reportRadio = 3;
                            if (e.msg == "Too many requests") {
                                this.$edMessage.error(this.$t("message.reportOnce"));
                            }
                        });
                });
            },
            cancelReport() {
                this.form.reportReason = "";
                this.form.reportRadio = 3;
            },

            setReportAlertValue(value = false, work, params, callback = null) {
                console.log(value);
                this.showReportReason = value;
                this.work = work;
                this.callback = callback;
            },
        },
    };
</script>
<i18n>
{
  "zh": {
    "bigger": "放大",
    "smaller": "缩小",
    "notes": "笔记",
    "image": "图形",
    "view": "浏览量",
    "like": "点赞",
    "collect": "收藏",
    "report": "举报",
    "share": "分享",
    "use": "使用此模板",
    "usedNums": "使用量",
    "cloneHint": {
      "memberFree": "会员免费",
      "free": "免费使用",
      "charge": "付费使用，需支付",
      "bought": "已购买，可直接使用"
    },
    "currency": {
      "unit": "元",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "举报成功！",
      "reportOnce": "你已经举报过此作品",
      "cloning": "加载中..."
    },
    "reportInstruction": "为了保护您和被举报人的权利，请您慎重填写举报原因，我们会认真核实。",
    "reportReasonHint": "举报原因（5个字符以上）*",
    "validateWarn": {
      "reasonRequire": "举报原因不能为空！",
      "reasonLength": "举报原因不能少于5个字符且不能多于240个字符！"
    },
    "reportResonLabel": "举报理由",
    "reportTypeLabel": "举报类型",
    "reportType1": "违法违规：色情、暴力、血腥、敏感信息等",
    "reportType2": "盗用作品：侵犯原创作者的版权",
    "reportType3": "垃圾广告：广告推销",
    "reportType4": "其他理由",
    "noSpaceVip": "云空间已满",
    "previewMode": "预览模式",
    "noteMode": "笔记模式",
    "okText": "确定",
    "cancelText": "取消"
  },
  "en": {
    "bigger": "Zoom in",
    "smaller": "Zoom out",
    "notes": "Notes",
    "image": "Image",
    "view": "Pageviews",
    "like": "Likes",
    "collect": "Favorites",
    "report": "Report",
    "share": "Share",
    "use": "Use immediately",
    "usedNums": "Usage amount",
    "cloneHint": {
      "memberFree": "Free for members",
      "free": "Free to Use",
      "charge": "Pay to Use",
      "bought": "Paid"
    },
    "currency": {
      "unit": "Dollar",
      "symbol": "$"
    },
    "message": {
      "reportSuccess": "Report successfully!",
      "reportOnce": "You have already reported this ",
      "cloning": "loading..."
    },
    "reportInstruction": "In order to protect the rights of you and the informant, please carefully fill in the reasons for reporting, we will carefully verify.",
    "reportReasonHint": "Report reason（Description should be at least 5 characters in length）*",
    "validateWarn": {
      "reasonRequire": "The report reason cannot be blank!",
      "reasonLength": "The reason for reporting cannot be less than 5 characters and no more than 240 characters!"
    },
    "reportResonLabel": "Reason",
    "reportTypeLabel": "Report type",
    "reportType1": "Violation of laws and regulations: pornography, violence, blood, sensitive information, etc.",
    "reportType2": "Misappropriation of works: infringement of the copyright of the original author",
    "reportType3": "Spam ads: advertising promotion",
    "reportType4": "Other reasons",
    "noSpaceVip": "The cloud storage is full.",
    "previewMode": "Preview mode",
    "noteMode": "Note mode",
    "okText": "OK",
    "cancelText": "Cancel"
  },
  "de": {
    "bigger": "Zoom in",
    "smaller": "Zoom out",
    "notes": "Notiz",
    "image": "Bild",
    "view": "Ansichten",
    "like": "Likes",
    "collect": "Favoriten",
    "report": "Bericht",
    "share": "Teilen",
    "use": "Diese Vorlage verwenden",
    "usedNums": "Nutzungsmenge",
    "cloneHint": {
      "memberFree": "Kostenlos für Mitglieder",
      "free": "Kostenlos zu benutzen",
      "charge": "Verwendung bezahlen",
      "bought": "Bezahlt"
    },
    "currency": {
      "unit": "RMB",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "Erfolgreich gemeldet!",
      "reportOnce": "Sie haben diese Arbeit bereits gemeldet",
      "cloning": "Wird geladen..."
    },
    "reportInstruction": "Um die Rechte von Ihnen und dem Informanten zu schützen, geben Sie bitte die Gründe für die Meldung sorgfältig an. Wir werden dies sorgfältig überprüfen.",
    "reportReasonHint": "Grund melden （Beschreibung sollte mindestens 5 Zeichen lang sein） *",
    "validateWarn": {
      "reasonRequire": "Der Berichtsgrund darf nicht leer sein!",
      "reasonLength": "Der Grund für die Meldung darf nicht weniger als 5 Zeichen und nicht mehr als 240 Zeichen betragen!"
    },
    "reportResonLabel": "Meldungsgrund",
    "reportTypeLabel": "Meldungstyp",
    "reportType1": "Verstöße gegen Gesetze und Vorschriften: Pornografie, Gewalt, Blut, sensible Informationen usw. ",
    "reportType2": "Veruntreuung von Werken: Verletzung des Urheberrechts des ursprünglichen Autors",
    "reportType3": "Spam-Anzeigen: Werbung",
    "reportType4": "Andere Gründe",
    "noSpaceVip": "Keinen Cloud-Speicherplatz",
    "previewMode": "Vorbild Modus",
    "noteMode": "Notiz-Modus",
    "okText": "Sichern",
    "cancelText": "Abbrechen"
  },
  "fr": {
    "bigger": "Zoom avant",
    "smaller": "Zoom arrière",
    "notes": "Notes",
    "image": "Graphique",
    "view": "Pages vues",
    "like": "Aimes",
    "collect": "Favoris",
    "report": "Rapport",
    "share": "Partager",
    "use": "Utilisez ce modèle",
    "usedNums": "Montant d'utilisation",
    "cloneHint": {
      "memberFree": "Gratuit pour les membres",
      "free": "Utilisation gratuite",
      "charge": "Payer pour utiliser",
      "bought": "Paid"
    },
    "currency": {
      "unit": "Euro",
      "symbol": "€"
    },
    "message": {
      "reportSuccess": "Rapporté avec succès!",
      "reportOnce": "Vous avez déjà signalé ce travail.",
      "cloning": "chargement..."
    },
    "reportInstruction": "Afin de protéger vos droits et ceux de l'informateur, veuillez indiquer soigneusement les raisons du signalement, nous vérifierons soigneusement.",
    "reportReasonHint": "Raison du rapport (la description doit comporter au moins 5 caractères) *",
    "validateWarn": {
      "reasonRequire": "La raison du rapport ne peut pas être vide!",
      "reasonLength": "La raison du signalement ne peut pas être inférieure à 5 caractères et pas plus de 240 caractères!"
    },
    "reportResonLabel": "Raison du signalement",
    "reportTypeLabel": "Type de rapport",
    "reportType1": "Violation des lois et règlements: pornographie, violence, sang, informations sensibles, etc.",
    "reportType2": "Détournement d'œuvres: violation du droit d'auteur de l'auteur original",
    "reportType3": "Annonces de spam: promotion publicitaire",
    "reportType4": "Autres raisons",
    "noSpaceVip": "L'espace nuage est plein",
    "previewMode": "Mode aperçu",
    "noteMode": "Mode note",
    "okText": "Créer",
    "cancelText": "Annuler"
  },
  "es": {
    "bigger": "Acercar",
    "smaller": "Alejar",
    "notes": "Notas",
    "image": "Gráfico",
    "view": "Páginas vistas",
    "like": "Likes",
    "collect": "Favoritos",
    "report": "Reportar",
    "share": "Compartir",
    "use": "Usa esta plantilla",
    "usedNums": "Cantidad de uso",
    "cloneHint": {
      "memberFree": "Gratis para miembros",
      "free": "Gratis",
      "charge": "Pagos",
      "bought": "Pagados"
    },
    "currency": {
      "unit": "Yuan",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "¡Reportado exitosamente!",
      "reportOnce": "Ya has reportado de este trabajo",
      "cloning": "cargando..."
    },
    "reportInstruction": "Con el fin de proteger los derechos de usted y del informante, por favor complete cuidadosamente las razones para informar, lo verificaremos cuidadosamente.",
    "reportReasonHint": "Motivo del reporte （La descripción debe tener al menos 5 caracteres de longitud） *",
    "validateWarn": {
      "reasonRequire": "¡El motivo del reporte no puede estar en blanco!",
      "reasonLength": "¡El motivo de la denuncia no puede tener menos de 5 caracteres ni más de 240 caracteres!"
    },
    "reportResonLabel": "Razón del reporte ",
    "reportTypeLabel": "Tipo de reporte ",
    "reportType1": "Violaciones y Sanciones: pornografía, violencia, sangre, información sensible, etc.",
    "reportType2": "Apropiación indebida de obras: infracción de los derechos de autor del autor original",
    "reportType3": "Anuncios de spam: promoción publicitaria",
    "reportType4": "Otras razones",
    "noSpaceVip": "El espacio en la nube está lleno",
    "previewMode": "Modo de vista previa",
    "noteMode": "Modo de nota",
    "okText": "Confirmar",
    "cancelText": "Cancelar"
  },
  "jp": {
    "bigger": "ズームイン",
    "smaller": "ズームアウト",
    "notes": "注釈",
    "image": "图形",
    "view": "ページビュー",
    "like": "いいね",
    "collect": "お気に入り",
    "report": "報告",
    "share": "共有",
    "use": "このテンプレートを使用する",
    "usedNums": "使用回数",
    "cloneHint": {
      "memberFree": "会員無料",
      "free": "無料機能",
      "charge": "有料機能",
      "bought": "購入済み"
    },
    "currency": {
      "unit": "元",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "正常に報告しました。",
      "reportOnce": "この作品はすでに報告されました。",
      "cloning": "読み込み中..."
    },
    "reportInstruction": "報告者と報告される方の権利を保護するため、報告理由を慎重に記入してください。",
    "reportReasonHint": "報告理由（5文字以上）*",
    "validateWarn": {
      "reasonRequire": "報告理由を記入してください。",
      "reasonLength": "報告する理由は、5文字以上240文字以下にする必要があります。"
    },
    "reportResonLabel": "報告理由",
    "reportTypeLabel": "報告タイプ",
    "reportType1": "法律違反：ポルノ、暴力、血、機密情報など",
    "reportType2": "著作物の無断使用：著作権侵害",
    "reportType3": "スパム広告：広告宣伝",
    "reportType4": "その他",
    "noSpaceVip": "クラウドストレージがいっぱいです",
    "previewMode": "预览模式",
    "noteMode": "笔记模式",
    "okText": "確認",
    "cancelText": "キャンセル"
  },
  "pt": {
    "bigger": "Prolongar",
    "smaller": "Encolher",
    "notes": "Notas",
    "image": "Gráficos",
    "view": "Visualizações de página",
    "like": "Gosto",
    "collect": "Coletar",
    "report": "Reportar",
    "share": "Compartihar",
    "use": "Usar este modelo",
    "usedNums": "Quantidade de uso",
    "cloneHint": {
      "memberFree": "Grátis para membros",
      "free": "Livre para usar",
      "charge": "Uso pago, precisar de pagar",
      "bought": "Foi comprado e pode ser usado diretamente"
    },
    "currency": {
      "unit": "yuan",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "Reportar com sucesso!",
      "reportOnce": "Você já reportou este trabalho",
      "cloning": "Carregando..."
    },
    "reportInstruction": "Para proteger os seus direitos e os do informante, preencha cuidadosamente os motivos da denúncia, que iremos verificar cuidadosamente.",
    "reportReasonHint": "Motivo da reporta (a descrição deve ter pelo menos 5 caracteres)*",
    "validateWarn": {
      "reasonRequire": "O motivo da reporta não pode ficar em branco!",
      "reasonLength": "O motivo da denúncia não pode ter menos de 5 caracteres e não mais de 240 caracteres!"
    },
    "reportResonLabel": "Razão da reporta",
    "reportTypeLabel": "Tipo da reporta",
    "reportType1": "Violação de leis e regulamentos: pornografia, violência, sangue, informações confidenciais, etc.",
    "reportType2": "Apropriação indébita de obras: violação dos direitos autorais do autor original",
    "reportType3": "Anúncios de spam: promoção de publicidade",
    "reportType4": "Outras razões",
    "noSpaceVip": "O espaço da nuvem está cheio",
    "previewMode": "Modo de pré-visualização",
    "noteMode": "Modo de nota",
    "okText": "OK",
    "cancelText": "Cancelar"
  },
  "it": {
    "bigger": "Ingrandire",
    "smaller": "Riduci lo zoom",
    "notes": "Appunti",
    "image": "Grafico",
    "view": "Visualizzazioni di pagina",
    "like": "Piace",
    "collect": "Preferiti",
    "report": "Rapporto",
    "share": "Condivide",
    "use": "Usa questo modello",
    "usedNums": "Quantità di utilizzo",
    "cloneHint": {
      "memberFree": "Gratuito per i membri",
      "free": "L'uso gratuito",
      "charge": "Paga per l'uso",
      "bought": "Pagato"
    },
    "currency": {
      "unit": "Euro",
      "symbol": "€"
    },
    "message": {
      "reportSuccess": "Segnalato con successo!",
      "reportOnce": "Hai già segnalato questo lavoro.",
      "cloning": "Caricamento in corso..."
    },
    "reportInstruction": "Al fine di tutelare i tuoi diritti e quelli dell'informatore, ti preghiamo di indicare attentamente i motivi della segnalazione, che controlleremo attentamente.",
    "reportReasonHint": "Motivo della segnalazione (la descrizione deve contenere almeno 5 caratteri)*",
    "validateWarn": {
      "reasonRequire": "Il motivo del rapporto non può essere vuoto！",
      "reasonLength": "Il motivo della segnalazione non può essere inferiore a 5 caratteri e non superiore a 240 caratteri!"
    },
    "reportResonLabel": "Motivo della relazione",
    "reportTypeLabel": "Tipo di rapporto",
    "reportType1": "Violazione di leggi e regolamenti: pornografia, violenza, sangue, informazioni sensibili, ecc.",
    "reportType2": "Appropriazione indebita di opere: violazione del copyright dell'autore originale",
    "reportType3": "Annunci spam: promozione pubblicitaria",
    "reportType4": "Altri motivi",
    "noSpaceVip": "Lo spazio cloud è pieno",
    "previewMode": "Modalità anteprima",
    "noteMode": "Modalità nota",
    "okText": "OK",
    "cancelText": "Annulla"
  },
  "tw": {
    "bigger": "放大",
    "smaller": "縮小",
    "notes": "筆記",
    "image": "圖形",
    "view": "瀏覽量",
    "like": "點讚",
    "collect": "收藏",
    "report": "舉報",
    "share": "分享",
    "use": "使用此模板",
    "usedNums": "使用量",
    "cloneHint": {
      "memberFree": "會員免費",
      "free": "免費使用",
      "charge": "付費使用，需支付",
      "bought": "已購買，可直接使用"
    },
    "currency": {
      "unit": "元",
      "symbol": "￥"
    },
    "message": {
      "reportSuccess": "舉報成功！",
      "reportOnce": "你已經舉報過此產品",
      "cloning": "加載中..."
    },
    "reportInstruction": "為了保護您和被舉報人的權利，請您謹慎填寫舉報原因，我們會認真核實。",
    "reportReasonHint": "舉報原因（5個字符以上）*",
    "validateWarn": {
      "reasonRequire": "舉報原因不能為空！",
      "reasonLength": "舉報原因不能少於5個字符且不能多於240個字符！"
    },
    "reportResonLabel": "舉報理由",
    "reportTypeLabel": "舉報類型",
    "reportType1": "違法違規：色情、暴力、血腥、敏感信息等",
    "reportType2": "盜用作品：侵犯原創作者的版權",
    "reportType3": "垃圾廣告：廣告推銷",
    "reportType4": "其他理由",
    "noSpaceVip": "雲端硬碟已滿",
    "previewMode": "預覽模式",
    "noteMode": "筆記模式",
    "okText": "確定",
    "cancelText": "取消"
  },
  "kr": {
    "bigger": "확대",
    "smaller": "축소",
    "notes": "노트",
    "image": "이미지",
    "view": "조회수",
    "like": "좋아요",
    "collect": "즐겨찾기",
    "report": "신고",
    "share": "공유",
    "use": "템플릿 적용하기",
    "usedNums": "적용수",
    "cloneHint": {
      "memberFree": "회원 무료",
      "free": "무료 사용",
      "charge": "유료 사용",
      "bought": "구매 완료, 사용 가능"
    },
    "currency": {
      "unit": "원",
      "symbol": "₩"
    },
    "message": {
      "reportSuccess": "신고 성공！",
      "reportOnce": "이미 신고했습니다!",
      "cloning": "로딩 중..."
    },
    "reportInstruction": "귀하와 피신고자의 권리를 보호하기 위해 신고 사유를 신중히 기입 해 주시면 꼼꼼하게 확인하겠습니다.",
    "reportReasonHint": "신고 이유（5자 이상）*",
    "validateWarn": {
      "reasonRequire": "신고 이유는 비워 둘 수 없습니다!",
      "reasonLength": "신고 이유는 5 자 이상 240 자 이하여야 합니다!"
    },
    "reportResonLabel": "신고 이유",
    "reportTypeLabel": "신고 유형",
    "reportType1": "법률 및 규정 위반 : 포르노, 폭력, 혈성, 민감한 정보 등",
    "reportType2": "저작물의 도용 : 원저작자의 저작권 침해",
    "reportType3": "스팸 : 광고",
    "reportType4": "기타 이유",
    "noSpaceVip": "클라우드 공간이 가득 찼습니다",
    "previewMode": "미리보기 모드",
    "noteMode": "노트 모드",
    "okText": "확인",
    "cancelText": "취소"
  },
  "id": {
    "bigger": "Perbesar",
    "smaller": "Perkecil",
    "notes": "Catatan",
    "image": "Gambar",
    "view": "Tampilan Halaman",
    "like": "Suka",
    "collect": "Favorit",
    "report": "Laporkan",
    "share": "Bagikan",
    "use": "Gunakan segera",
    "usedNums": "Jumlah penggunaan",
    "cloneHint": {
      "memberFree": "Gratis untuk anggota",
      "free": "Penggunaan Gratis",
      "charge": "Penggunaan Berbayar",
      "bought": "Berbayar"
    },
    "currency": {
      "unit": "Dolar",
      "symbol": "$"
    },
    "message": {
      "reportSuccess": "Laporan berhasil!",
      "reportOnce": "Anda telah melaporkan hal ini ",
      "cloning": "memuat ...."
    },
    "reportInstruction": "Untuk melindungi hak Anda dan informan, isi alasan pelaporan dengan teliti, kami akan memverifikasi dengan cermat.",
    "reportReasonHint": "Alasan laporan（Deskripsi harus berisi setidaknya 5 karakter）*",
    "validateWarn": {
      "reasonRequire": "Alasan laporan tidak boleh kosong!",
      "reasonLength": "Alasan pelaporan tidak boleh kurang dari 5 karakter dan tidak lebih dari 240 karakter!"
    },
    "reportResonLabel": "Alasan",
    "reportTypeLabel": "Jenis laporan",
    "reportType1": "Pelanggaran terhadap undang-undang dan peraturan: pornografi, kekerasan, darah, informasi sensitif, dsb.",
    "reportType2": "Penyalahgunaan karya: pelanggaran hak cipta penulis asli",
    "reportType3": "Iklan spam: Promosi iklan",
    "reportType4": "Alasan lain",
    "noSpaceVip": "Penyimpanan cloud penuh.",
    "previewMode": "Mode pratinjau",
    "noteMode": "Mode catatan",
    "okText": "OKE",
    "cancelText": "Batalkan"
  }
}
</i18n>
